module.exports = {
  about: '關於',
  activities: '活動',
  awards: '獎項',
  hero_main: 'EI Fiesta',
  hero_sub: 'Broadening horizons with learning activities',
  btn_text: '查看活動列表',
  eieu: '香港教育大學圖書館企業及創新教育組',
  tel: '電話',
  email: '電郵',
};